import { bidUseProductionApi, bidNotaryApi, bidDetailApi } from '@/api/online/index'
// initial state
const state = {
  bidUseProduction: [],
  bidNotary: [],
  bidDetail: {},
  bidDetailProd: {}
}

// getters
const getters = {}

// actions
const actions = {
  // 获取所有用途和产品
  bidUseProductionAction ({ commit }) {
    return new Promise((resolve, reject) => {
      bidUseProductionApi().then(response => {
        if (response.status === '2000') {
          commit('setBidUseProduction', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取所有事项
  bidNotaryAction ({ commit }) {
    return new Promise((resolve, reject) => {
      bidNotaryApi().then(response => {
        if (response.status === '2000') {
          commit('setBidNotary', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取申办说明
  bidDetailAction ({ commit }, qurey) {
    return new Promise((resolve, reject) => {
      bidDetailApi(qurey).then(response => {
        if (response.status === '2000') {
          commit('setBidDetail', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取申办说明
  bidDetailProdAction ({ commit }, qurey) {
    return new Promise((resolve, reject) => {
      bidDetailApi(qurey).then(response => {
        if (response.status === '2000') {
          commit('setBidDetailProd', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}

// mutations
const mutations = {
  setBidUseProduction (state, bidUseProduction) {
    state.bidUseProduction = bidUseProduction
  },
  setBidNotary (state, bidNotary) {
    state.bidNotary = bidNotary
  },
  setBidDetail (state, bidDetail) {
    state.bidDetail = bidDetail
  },
  setBidDetailProd (state, bidDetailProd) {
    state.bidDetailProd = bidDetailProd
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/online/index.js